import { render, staticRenderFns } from "./SalesWithoutInvoices.vue?vue&type=template&id=6242dab3&scoped=true&"
import script from "./SalesWithoutInvoices.vue?vue&type=script&lang=js&"
export * from "./SalesWithoutInvoices.vue?vue&type=script&lang=js&"
import style0 from "./SalesWithoutInvoices.vue?vue&type=style&index=0&id=6242dab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242dab3",
  null
  
)

export default component.exports